import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { CurrencyResource } from "@exonn/js-sdk";

export const module: Module<CurrencyResource> = {
  id: ResourceEnum.Currency,
  name: (t: TFunction) => t("moduleName.currencies"),
  smallIcon: <i className="icon-15-currency" />,
  bigIcon: <i className="icon-20-currency" />,

  list: {
    hideDeleteAction: (row) => row.is_default,
  },
  tabs: {
    edit: {
      getTitle: (resource: CurrencyResource) => resource.iso,
    },
  },
};
